export default __webpack_public_path__ + "static/media/MARC-PrivacyPractices.50dea14a.pdf";